import { render, staticRenderFns } from "./CollapsibleContainer.vue?vue&type=template&id=679fa0e0"
import script from "./CollapsibleContainer.vue?vue&type=script&lang=js"
export * from "./CollapsibleContainer.vue?vue&type=script&lang=js"
import style0 from "./CollapsibleContainer.vue?vue&type=style&index=0&id=679fa0e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports